<!--
 * @Author: DY
 * @Date: 2025-02-25 18:22:22
 * @LastEditTime: 2025-04-15 15:30:32
 * @Description: 产成品入库表单【仓储管理-产成品入库】
 * @FilePath: \ShiMo_Mobile\src\views\storage\finishedProductStorage\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="finishedProductStorageForm commonFormStyles">
            <HeaderNav header-title="产成品入库表" left-icon-name="2" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="入库信息">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>入库信息</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.InstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="制单日期"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.BillDate"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field name="radio" label="入库类型" class="fieldRadio" :left-icon="require('@/assets/images/icons/icon_5@2x.png')">
                                        <template #input>
                                            <van-radio-group
                                                v-model="formData.InstockType"
                                                direction="horizontal"
                                                :disabled="isDisabled || (formData.CardList || []).length > 0"
                                                ref="instockTypeRadioGroup"
                                            >
                                                <van-radio v-for="(item, index) in instockTypes" :key="`type_${index}`" :name="Number(item.Code)" checked-color="#ee0a24">
                                                    {{ item.Name }}
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li>
                                <!-- <li>
                                    <van-field name="radio" label="产品分类" class="fieldRadio" :left-icon="require('@/assets/images/icons/icon_5@2x.png')">
                                        <template #input>
                                            <van-radio-group disabled v-model="formData.ProductCategory" direction="horizontal">
                                                <van-radio :name="0" checked-color="#ee0a24">
                                                    产成品
                                                </van-radio>
                                                <van-radio :name="1" checked-color="#ee0a24">
                                                    附属产品
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li> -->
                                <template v-if="![0, 4].includes(formData.InstockType)">
                                    <li>
                                        <van-field
                                            readonly
                                            label="来源单据编号"
                                            placeholder="选择来源单据编号"
                                            :disabled="isDisabled"
                                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                            v-model="formData.SourceNumbers"
                                            @click="selectSource"
                                        ></van-field>
                                    </li>
                                </template>
                                <template v-if="![0, 4].includes(formData.InstockType)">
                                    <li>
                                        <van-field
                                            disabled
                                            label="出库仓库"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                            v-model="formData.OutStockNames"
                                        ></van-field>
                                    </li>
                                </template>
                                <li>
                                    <van-field
                                        readonly
                                        label="仓库编号"
                                        placeholder="选择仓库"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.StockCode"
                                        @click="selectWarehouse"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="库位编号"
                                        placeholder="选择库位"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.GridCode"
                                        @click="selectWarehouseLocation"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库位名称"
                                        placeholder="选择库位"
                                        :left-icon="require('@/assets/images/icons/icon_32@2x.png')"
                                        v-model="formData.GridName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库总数量（包）"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                                        v-model="formData.TotalInstockCount"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库总重量（吨）"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_44@2x.png')"
                                        v-model="formData.TotalInstockWeight"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.InstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.InstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="入库部门"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.InstockDeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="入库明细">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>入库明细</h5>
                                    <button type="button" v-if="!isDisabled" class="scanCodeButton" @click="scanCodeAdd">
                                        扫码
                                    </button>
                                    <van-icon name="add" v-if="!isDisabled" @click="addProductCard"></van-icon>
                                </li>
                                <dl class="materialList" v-for="(item, index) in formData.CardList" :key="`material_${index}`">
                                    <dt>
                                        <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(item, index)"></van-icon>
                                        <!-- <h5>产品卡号</h5> -->
                                        <p>{{ item.ProductCardNumber }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>物料代码：</p>
                                            <input type="text" disabled v-model="item.MaterialCode">
                                        </div>
                                        <div>
                                            <p>短描述：</p>
                                            <input type="text" disabled v-model="item.MaterialShortName">
                                        </div>
                                        <div>
                                            <p>生产部门/车间：</p>
                                            <input type="text" disabled v-model="item.ProductWorkshopName">
                                        </div>
                                        <div>
                                            <p>生产日期：</p>
                                            <input type="text" disabled v-model="item.ProductDate">
                                        </div>
                                        <div>
                                            <p>单包重量（吨）：</p>
                                            <input type="text" disabled v-model="item.PackageSingleWeight">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" v-if="(formData.Id || '') != ''" @click="submitForm">
                        确认入库
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
            <van-dialog v-model="confirmDialog" title="入库确认" show-cancel-button class="confirmPopUp" @confirm="confirmChilck">
                <table>
                    <thead>
                        <tr>
                            <th>短描述</th>
                            <th>入库数量(吨)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in confirmMaterialList" :key="`material_${index}`">
                            <td>{{ item.MaterialShortName }}</td>
                            <td>{{ item.PackageSingleWeight }}</td>
                        </tr>
                        <tr>
                            <th>总计</th>
                            <th>{{ confirmTotal }}</th>
                        </tr>
                    </tbody>
                </table>
            </van-dialog>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'finished-product-storage-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/finishedProductStorage') {
            this.$store.commit('noKeepAlive', 'finished-product-storage-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            instockTypes: [],
            formData: {
                Id: '',
                InstockNumber: '',
                BillDate: '',
                InstockType: null,
                ProductCategory: 0,
                SourceIds: '',
                SourceNumbers: '',
                OutStockIds: '',
                OutStockCodes: '',
                OutStockNames: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                MaterialCodes: '',
                MaterialShortNames: '',
                TotalInstockCount: 0,
                TotalInstockWeight: 0,
                Remarks: '',
                InstockDeptName: '',
                InstockDeptId: '',
                CardList: [],
            },
            MaterialCodes: '',
            Status: '',
            currentMaterial: {},
            isSaveOperation: false,

            confirmDialog: false,
            confirmMaterialList: [],
            confirmTotal: 0,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.source) {
            this.formData.SourceIds = this.$route.params.source.map(item => item.source_id).toString();
            this.formData.SourceNumbers = this.$route.params.source.map(item => item.source_number).toString();
            this.formData.OutStockIds = this.$route.params.source.map(item => item.stock_id).toString();
            this.formData.OutStockCodes = this.$route.params.source.map(item => item.stock_code).toString();
            this.formData.OutStockNames = this.$route.params.source.map(item => item.stock_name).toString();
            this.formData.Remarks = this.$route.params.source.map(item => item.remarks).toString();
            this.resetWarehouseLocation();
        }
        if (this.$route.params.warehouse) {
            this.formData.StockId = this.$route.params.warehouse[0].id;
            this.formData.StockCode = this.$route.params.warehouse[0].stock_code;
            this.formData.StockName = this.$route.params.warehouse[0].stock_name;
            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
        }
        if (this.$route.params.warehouseLocation) {
            this.formData.GridId = this.$route.params.warehouseLocation[0].id;
            this.formData.GridCode = this.$route.params.warehouseLocation[0].grid_code;
            this.formData.GridName = this.$route.params.warehouseLocation[0].grid_name;
            this.selectWarehouseLocationCallback(this.formData.GridId);
        }
        if (this.$route.params.productCard) {
            this.addProductCardCallback(this.$route.params.productCard);
        }
    },
    created() {
        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_ccprk;
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            try {
                const type = this.$route.params.type;
                this.instockTypes = await this.getInstockType();
                if (type === 'new') {
                    this.formData.BillDate = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    this.formData.InstockUserName = this.$takeTokenParameters('Name');
                }
                if (type === 'see') {
                    this.isDisabled = true;
                }
                if (type === 'edit' || type === 'see') {
                    this.formData = await this.getFormData(this.$route.params.id);
                    if ((this.formData.GridId || '') !== '') {
                        this.selectWarehouseLocationCallback(this.formData.GridId);
                    }
                }
                this.formData.InstockDeptName = this.$takeTokenParameters('DeptName');
                this.formData.InstockDeptId = this.$takeTokenParameters('DeptId');
                // 确保在设置初始值后再绑定事件
                this.$nextTick(() => {
                    this.$refs.instockTypeRadioGroup.$on('change', this.selectOutboundType);
                });
            } finally {
                this.$toast.clear();
            }
        },

        resetWarehouseLocation() {
            this.formData.StockId = '';
            this.formData.StockCode = '';
            this.formData.StockName = '';
            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
        },

        selectOutboundType() {
            this.MaterialCodes = '';
            this.formData.SourceId = '';
            this.formData.SourceNumber = '';
            this.formData.MaterialCodes = '';
            this.formData.MaterialShortNames = '';
            this.resetWarehouseLocation();
        },

        selectSource() {
            if (this.isDisabled) {return;}
            if (!this.formData.InstockType) {
                this.$toast.fail('请先选择入库类型！');
                return;
            }
            const typeConfig = {
                1: {
                    listCode: 'instock_ccp_choose_source1',
                    type: 'checkbox',
                    headerList: [{
                        name: '出库编号',
                        code: 'source_number',
                        isTitle: true,
                    }, {
                        name: '出库类型',
                        code: 'outstock_type_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_5@2x',
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '出库时间',
                        code: 'outstock_time',
                        icon: 'icon_7@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_codes',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_names',
                        icon: 'icon_28@2x',
                    }, {
                        name: '出库重量',
                        code: 'total_outstock_weight',
                        icon: 'icon_44@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
                2: {
                    listCode: 'instock_ccp_choose_source23',
                    headerList: [{
                        name: '混料通知单编号',
                        code: 'source_number',
                        isTitle: true,
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '成品数量',
                        code: 'product_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '登记人',
                        code: 'creator',
                        icon: 'icon_8@2x',
                    }, {
                        name: '确认人',
                        code: 'confirm_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '确认时间',
                        code: 'confirm_time',
                        icon: 'icon_7@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
                3: {
                    listCode: 'instock_ccp_choose_source23',
                    headerList: [{
                        name: '混料通知单编号',
                        code: 'source_number',
                        isTitle: true,
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '成品数量',
                        code: 'product_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '登记人',
                        code: 'creator',
                        icon: 'icon_8@2x',
                    }, {
                        name: '确认人',
                        code: 'confirm_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '确认时间',
                        code: 'confirm_time',
                        icon: 'icon_7@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
                5: {
                    listCode: 'instock_ccp_choose_source5',
                    headerList: [{
                        name: '汽运单编号',
                        code: 'source_number',
                        isTitle: true,
                    }, {
                        name: '供货单编号',
                        code: 'supply_number',
                        icon: 'icon_1@2x',
                    }, {
                        name: '短描述',
                        code: 'material_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '供应商',
                        code: 'supplier_name',
                        icon: 'icon_4@2x',
                    }, {
                        name: '供货日期',
                        code: 'supply_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '需求部门',
                        code: 'apply_dept_names',
                        icon: 'icon_29@2x',
                    }, {
                        name: '车牌号',
                        code: 'plate_number',
                        icon: 'icon_18@2x',
                    }, {
                        name: '司机',
                        code: 'driver_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '联系电话',
                        code: 'driver_phone',
                        icon: 'icon_9@2x',
                    }, {
                        name: '到场时间',
                        code: 'into_time',
                        icon: 'icon_7@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
                6: {
                    listCode: 'instock_ccp_choose_source6',
                    headerList: [{
                        name: '质量验收单号',
                        code: 'source_number',
                        isTitle: true,
                    }, {
                        name: '合同编号',
                        code: 'contract_no',
                        icon: 'icon_1@2x',
                    }, {
                        name: '客户名称',
                        code: 'client_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_codes',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_names',
                        icon: 'icon_28@2x',
                    }, {
                        name: '发货数量（吨）',
                        code: 'delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }, {
                        name: '登记日期',
                        code: 'register_date',
                        icon: 'icon_7@2x',
                    }],
                },
            };
            const { listCode = '', type = 'radio', headerList = [] } = typeConfig[this.formData.InstockType] || {};
            this.$router.isBack = 2;
            let requestUrl = '/basicplatform/tabledata';
            if (this.formData.InstockType === 1 || this.formData.InstockType === '1') {
                requestUrl = '/basicplatform/tabledata?&productCategory=0';
            }
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择来源单据',
                    sourcePath: 'finishedProductStorageForm',
                    callbackDataKey: 'source',
                    relationKey: 'source_id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList,
                    listCode,
                    requestUrl: requestUrl,
                    type,
                },
            });
        },
        selectWarehouse() {
            if (this.isDisabled) { return; }
            if (this.formData.InstockType === null) {
                this.$toast.fail('请先选择入库类型！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'finishedProductStorageForm',
                    listCode: 'instock_ccp_xzck',
                    callbackDataKey: 'warehouse',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_5@2x',
                    }],
                },
            });
        },

        selectWarehouseLocation() {
            if (this.isDisabled) {return;}
            if ((this.formData.StockId || '') === '') {
                this.$toast.fail('请先选择仓库！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择库位',
                    sourcePath: 'finishedProductStorageForm',
                    requestUrl: `/basicplatform/tabledata?stockCode=${this.formData.StockCode}`,
                    listCode: 'instock_ccp_xzkw',
                    callbackDataKey: 'warehouseLocation',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '库位编号',
                        code: 'grid_code',
                        isTitle: true,
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_5@2x',
                    }],
                },
            });
        },
        async selectWarehouseLocationCallback(GridId) {
            const res = await this.getWarehouseLocationMaterials(GridId);
            if ((res.materials || []).length === 0) {
                parent.$globalHub.$message('该库位没有设置物料，请先设置物料');
                return;
            }
            this.formData.MaterialCodes = this.MaterialCodes = res.materials.map(item => item.MaterialCode).toString();
            this.formData.MaterialShortNames = res.materials.map(item => item.MaterialShortName).toString();
        },
        async addProductCard() {
            if ((this.formData.Id || '') === '') {
                this.$toast.fail('请先保存入库单！');
                return;
            }
            if ((this.formData.GridCode || '') === '' || (this.formData.StockCode || '') === '') {
                this.$toast.fail('请先选择库位！');
                return;
            }
            let listCode = '';
            const filterCards = (this.formData.CardList || []).map(item => item.ProductCardNumber).toString();
            let queryString = `materialCodes=${this.MaterialCodes}&filterCards=${filterCards}`;
            if ([0, 3, 4].includes(this.formData.InstockType)) {
                listCode = 'instock_ccp_choose_card0';
            } else if ([1, 2, 5, 6].includes(this.formData.InstockType)) {
                if (this.formData.SourceIds === '') {
                    this.$toast.fail('请先选择来源单据编号！');
                    return;
                }
                queryString = `${queryString}&sourceId=${this.formData.SourceIds}`;
                listCode = `instock_ccp_choose_card${this.formData.InstockType}`;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择产品卡',
                    sourcePath: 'finishedProductStorageForm',
                    requestUrl: `/basicplatform/tabledata?${queryString}`,
                    listCode,
                    callbackDataKey: 'productCard',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    pageSize: 100,
                    showTotal: true,
                    totalKey: 'package_single_weight',
                    headerList: [{
                        name: '产品卡号',
                        code: 'product_card_number',
                        isTitle: true,
                    }, {
                        name: '批次号',
                        code: 'batch_number',
                        icon: 'icon_18@2x',
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_46@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '内部标识',
                        code: 'sign_internal',
                        icon: 'icon_43@2x',
                    }, {
                        name: '生产日期',
                        code: 'product_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '生产车间',
                        code: 'product_workshop_name',
                        icon: 'icon_45@2x',
                    }, {
                        name: '班次',
                        code: 'product_schedule_name',
                        icon: 'icon_5@2x',
                    }, {
                        name: '班组',
                        code: 'product_team_name',
                        icon: 'icon_5@2x',
                    }, {
                        name: '单包重量（吨）',
                        code: 'package_single_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
            });
        },

        scanCodeAdd() {
            if ((this.formData.Id || '') === '') {
                this.$toast.fail('请先保存入库单！');
                return;
            }
            if ((this.formData.GridCode || '') === '' || (this.formData.StockCode || '') === '') {
                this.$toast.fail('请先选择库位！');
                return;
            }
            this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },
        async jyCallback_DriveScanFinished_ccprk(val) {
            const data = JSON.parse(`${val}`.slice(1, -1));
            const res = (this.formData.CardList || []).filter(item => item.ProductCardNumber === data.ProductCardNumber);
            if ((res || []).length > 0) {
                this.$toast.fail('产品卡已存在，请勿重复添加！');
                return;
            }
            const productCardInfo = await this.getProductCardInfo(data.ProductCardNumber);
            if (productCardInfo && this.MaterialCodes.includes(productCardInfo.MaterialCode)) {
                const addProductCardList = [{
                    BatchNumber: productCardInfo.BatchNumber,
                    ProductCardNumber: productCardInfo.ProductCardNumber,
                    MaterialCode: productCardInfo.MaterialCode,
                    MaterialName: productCardInfo.MaterialName,
                    MaterialShortName: productCardInfo.MaterialShortName,
                    MaterialUnit: productCardInfo.MaterialUnit,
                    ProductWorkshopCode: productCardInfo.ProductWorkshopCode,
                    ProductWorkshopName: productCardInfo.ProductWorkshopName,
                    ProductDate: productCardInfo.ProductDate,
                    PackageSingleWeight: productCardInfo.PackageSingleWeight,
                }];
                const res = await this.addProductCardRequest(this.formData.Id, addProductCardList);
                if (res) {
                    this.$toast('新增成功！');
                    this.formData.CardList = this.formData.CardList ?? [];
                    this.formData.CardList.unshift(...addProductCardList);
                }
            } else {
                this.$toast.fail('当前产品卡和库位不匹配，请重新扫描！');
            }
        },

        async deleteMaterial(item, index) {
            const res = await this.deleteProductCardRequest(this.formData.Id, [item.ProductCardNumber]);
            if (res) {
                this.formData.CardList.splice(index, 1);
                this.$toast(`产品卡【${item.ProductCardNumber}】已删除。`);
            }
        },
        async addProductCardCallback(data) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const addProductCardList = [];
            data.forEach(item => {
                const addProductCard = {
                    BatchNumber: item.batch_number,
                    ProductCardNumber: item.product_card_number,
                    MaterialCode: item.material_code,
                    MaterialName: item.material_name,
                    MaterialShortName: item.material_short_name,
                    MaterialUnit: item.material_unit,
                    ProductWorkshopCode: item.product_workshop_code,
                    ProductWorkshopName: item.product_workshop_name,
                    ProductDate: item.product_date,
                    PackageSingleWeight: item.package_single_weight,
                };
                if (this.formData.InstockType === 1) {
                    addProductCard.OutStockId = item.stock_id;
                    addProductCard.OutStockCode = item.stock_code;
                    addProductCard.OutStockName = item.stock_name;
                }
                addProductCardList.push(addProductCard);
            });
            const res = await this.addProductCardRequest(this.formData.Id, addProductCardList);
            if (res) {
                this.$toast('新增成功！');
                this.formData.CardList = this.formData.CardList ?? [];
                this.formData.CardList.unshift(...addProductCardList);
            }
            this.$toast.clear();
        },
        async saveForm() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.saveFormData(this.formData);
            if (res) {
                this.formData = res;
                this.isSaveOperation = true;
                this.$toast.success('保存成功。');
            }
            this.$toast.clear();
        },
        async submitForm() {
            if ((this.formData.CardList || []).length === 0) {
                this.$toast.fail('请先添加产品卡！');
                return;
            }
            const materialMap = this.formData.CardList.reduce((acc, cur) => {
                const key = cur.MaterialShortName;
                if (!acc[key]) {
                    acc[key] = { MaterialShortName: key, PackageSingleWeight: 0 };
                }
                acc[key].PackageSingleWeight = NP.plus( acc[key].PackageSingleWeight, Number(cur.PackageSingleWeight || 0));
                return acc;
            }, {});
            this.confirmMaterialList = Object.values(materialMap).map(item => ({ ...item, PackageSingleWeight: NP.round(item.PackageSingleWeight, 4) }));
            this.confirmTotal = NP.round(this.confirmMaterialList.reduce((sum, item) => NP.plus(sum, item.PackageSingleWeight), 0), 4);
            this.confirmDialog = true;
        },
        async confirmChilck() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.submitFormData(this.formData.Id);
            if (res) {
                this.isSaveOperation = true;
                this.$toast.success('入库成功。');
                this.closeAllocationForm();
            }
            this.$toast.clear();
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'finishedProductStorage',
                params: {
                    saveCallback: this.isSaveOperation,
                },
            });
        },

        // 获取出库类型
        getInstockType() {
            return this.$axios.$get('/interfaceApi/sale/tbcode/getbytype/instock_type');
        },
        // 获取表单数据
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/instock_ccp/get/${id}`);
        },
        // 获取库位下物料信息
        getWarehouseLocationMaterials(grid_id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid/get/${grid_id}`);
        },
        // 新增产品卡
        addProductCardRequest(id, requestData) {
            return this.$axios.$post(`/interfaceApi/sale/instock_ccp/addcard/${id}`, requestData);
        },
        // 删除产品卡
        deleteProductCardRequest(id, requestData) {
            return this.$axios.$post(`/interfaceApi/sale/instock_ccp/deletecard/${id}`, requestData);
        },
        // 获取产品卡信息
        getProductCardInfo(productCardNumber) {
            return this.$axios.$get(`/interfaceApi/sale/product_card_flake/${productCardNumber}`);
        },
        // 保存入库单
        saveFormData(requestData) {
            return this.$axios.$post('/interfaceApi/sale/instock_ccp/create', requestData);
        },
        // 提交入库单
        submitFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/instock_ccp/confirm/${id}`);
        },
    },
};
</script>
<style lang="stylus">
.finishedProductStorageForm
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .van-radio-group
                .van-radio
                    width 100%
            .formItemTitle
                .scanCodeButton
                    color #E93743
                    font-size 12rpx
                    margin-right auto
                    margin-left 10rpx
                    width: 52rpx;
                    height: 26rpx;
                    line-height 24rpx;
                    background: rgba(233,55,67,0.1);
                    border-radius: 2rpx;
                    border: 1px solid rgba(233,55,67,0.2)
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                // h5
                //     font-size 16rpx
                //     color #e93743
                p
                    // margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
    .confirmPopUp
        width 90%
        border-radius 8rpx
        .van-dialog__header
            font-size 16rpx
            color #E93543
            padding 14rpx 0
            border-bottom 1px solid rgba(231, 230, 230, 1)
            background: linear-gradient( 180deg, #FFF4F2 0%, #FFFFFF 100%);
        .van-dialog__content
            padding 10rpx
            max-height: 60vh;
            overflow-y: auto;
            table
                width 100%
                border-collapse collapse;
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
                border-radius: 4px;
                border: 1px solid #E7E6E6;
                overflow: hidden;
                th,td
                    border 1px solid #E7E6E6
                    font-size 14rpx
                    text-align center
                    height 36rpx
</style>
